import axios from "axios"

const fetchCompanyInfoRequest = () => {
	return {type: "FETCH_COMPANY_INFO_REQUEST"}
}

const fetchCompanyInfoSuccess = (company_info) => {
	return {type: "FETCH_COMPANY_INFO_SUCCESS", payload: company_info}
}

const fetchCompanyInfoFailure = (error) => {
	return {type: "FETCH_COMPANY_INFO_FAILURE", payload: error}
}

export const fetchCompanyInfo = (username) => {
	return (dispatch) => {
		dispatch(fetchCompanyInfoRequest())
        axios.get(`${username}`)
		.then(response => {
			const company_info = response.data
			dispatch(fetchCompanyInfoSuccess(company_info))	
		})
		.catch(err => {
			const error = err.response.status
			dispatch(fetchCompanyInfoFailure(error))
		})
	}
}